import {
    Injectable,
    signal,
} from '@angular/core';

import {
    Currency,
    currencies,
} from 'src/app/core/constants/currencies';

/** The currency of the shop, with the separators of the user language (not known until the configuration is set up). */
export type CurrentCurrency = Currency & {
    decimal_separator?: string;
    thousands_separator?: string;
};

/**
 * The currency the application shows amounts in. `ConfigurationManagerService` keeps it up to date; the AngularJS filters
 * and controllers read `currency()`. It replaces `$rootScope.currentCurrency`.
 *
 * The value is never modified, a change replaces it, and the shared `currencies` table is never written to.
 */
@Injectable({
    providedIn: 'root',
})
export class CurrentCurrencyService {
    private readonly state = signal<CurrentCurrency>({ ...currencies['EUR'] });

    public readonly currency = this.state.asReadonly();

    /** Changes the currency by its code (EUR when it is unknown), keeping the separators already set. */
    public setCurrency(code: string): void {
        this.state.update(({ decimal_separator, thousands_separator }) => ({
            ...(currencies[code] || currencies['EUR']),
            decimal_separator,
            thousands_separator,
        }));
    }

    public setSeparators(decimalSeparator: string, thousandsSeparator: string): void {
        this.state.update((current) => ({
            ...current,
            decimal_separator: decimalSeparator,
            thousands_separator: thousandsSeparator,
        }));
    }
}
